import { Link, NavLink, Outlet, useParams } from "react-router-dom";
import * as api from "../api/client";
import { usePolledResource } from "../hooks/usePolling";
import { HealthBadge } from "../components/HealthBadge";
import { AuthenticationStatus } from "../components/AuthenticationStatus";

const POLL_INTERVAL_MS = 15_000;

export interface ServerOutletContext {
  detail: api.ServerDetail;
  refresh: () => void;
}

const TABS = [
  { to: "", label: "Status", end: true },
  { to: "players", label: "Players", end: false },
  { to: "chat", label: "Chat", end: false },
  { to: "helper", label: "Helper", end: false },
  { to: "message-logs", label: "Message Logs", end: false },
];

export function ServerLayout() {
  const { id } = useParams<{ id: string }>();
  const fetcher = () => api.getServer(id!);
  const { data, loading, error, refresh } = usePolledResource(fetcher, POLL_INTERVAL_MS, id);

  if (loading) {
    return <p className="muted">Loading server…</p>;
  }

  if (error || !data) {
    return (
      <div className="empty-state">
        <p style={{ marginBottom: "var(--space-3)" }}>{error ?? "Server not found."}</p>
        <Link to="/servers" className="btn">
          Back to servers
        </Link>
      </div>
    );
  }

  const { server } = data;

  return (
    <>
      <div className="topbar">
        <div className="page-title-group">
          <h1>{server.display_name}</h1>
          <p className="mono">{server.id}</p>
        </div>
        <div className="row">
          <HealthBadge state={server.health_state} />
          <AuthenticationStatus state={server.authentication_state} />
        </div>
      </div>

      <div className="tabs">
        {TABS.map((tab) => (
          <NavLink
            key={tab.label}
            to={tab.to}
            end={tab.end}
            className={({ isActive }) => `tab${isActive ? " active" : ""}`}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet context={{ detail: data, refresh } satisfies ServerOutletContext} />
    </>
  );
}
